module.exports = __webpack_public_path__ + "4bfdc4eb14844c8c719d446f97ec2606.svg";